import { emptyIfInvalid } from '../../../utils/value.js';
import { ColorReference, Float, Gradient, Keyword, Length, LengthOrPosition } from '../../values/index.js';
import { fixReference as fixColorReference } from '../basic/color.js';
import { Set } from '../../index.js';
// Color/Gradient fill
export const Color = (props = {}) => ({
    backgroundColor: ColorReference(props.backgroundColor),
    backgroundGradient: Gradient(props.backgroundGradient)
});
Color.isValid = ({ backgroundColor, backgroundGradient }) => 'red' in backgroundColor || ColorReference.isValid(backgroundColor) || Gradient.isValid(backgroundGradient);
// CSS effects
export const Effects = (props = {}) => {
    var _a;
    return ({
        blur: Length(props.blur),
        opacity: (_a = Float(props.opacity)) !== null && _a !== void 0 ? _a : 1
    });
};
Effects.isValid = ({ blur, opacity }) => blur.value != 0 || opacity != 1;
// Background images
export var BackgroundRepeat;
(function (BackgroundRepeat) {
    BackgroundRepeat["repeat"] = "repeat";
    BackgroundRepeat["no-repeat"] = "no-repeat";
    BackgroundRepeat["repeat-x"] = "repeat-x";
    BackgroundRepeat["repeat-y"] = "repeat-y";
})(BackgroundRepeat = BackgroundRepeat || (BackgroundRepeat = {}));
export var BackgroundSize;
(function (BackgroundSize) {
    BackgroundSize["cover"] = "cover";
    BackgroundSize["contain"] = "contain";
})(BackgroundSize = BackgroundSize || (BackgroundSize = {}));
export const Image = (props = {}) => {
    var _a;
    return ({
        backgroundImage: (_a = props.backgroundImage) !== null && _a !== void 0 ? _a : '',
        backgroundPositionX: LengthOrPosition(props.backgroundPositionX),
        backgroundPositionY: LengthOrPosition(props.backgroundPositionY),
        backgroundRepeat: Keyword(props.backgroundRepeat, BackgroundRepeat, 'repeat'),
        backgroundSize: Keyword(props.backgroundSize, BackgroundSize, 'cover')
    });
};
Image.isValid = ({ backgroundImage }) => backgroundImage != null;
export const Props = (props = {}) => ({
    ...emptyIfInvalid(props, Color),
    ...emptyIfInvalid(props, Effects),
    ...emptyIfInvalid(props, Image)
});
export const fix = (props, styles) => {
    var _a;
    return ({
        ...props,
        backgroundColor: fixColorReference(props.backgroundColor, styles),
        backgroundGradient: {
            ...props.backgroundGradient,
            stops: (_a = props.backgroundGradient) === null || _a === void 0 ? void 0 : _a.stops.map((stop) => ({
                ...stop,
                color: fixColorReference(stop.color, styles)
            }))
        }
    });
};
export const validate = () => true;
export const type = 'fill';
export const label = 'Fill';
export const category = 'aspect';
export const property = 'fillIds';
export const forms = [
    { id: 'fillColor', label: 'Color', extractProperties: (props) => Color(props), validate: Color.isValid },
    {
        id: 'fillEffects',
        label: 'Effects',
        extractProperties: (props) => Effects(props),
        validate: Effects.isValid
    }
];
export const summarize = (props, styles, formId) => {
    const color = Set.findByTypeAndId(styles || [], 'color', props.backgroundColor.id);
    switch (formId) {
        case 'fillEffects':
            const effects = [];
            if (props.blur.value > 0)
                effects.push('blur');
            if (props.opacity < 1)
                effects.push('opacity');
            return effects.join(' / ') || 'None';
        case 'fillColor':
            return `${props.backgroundGradient.stops.length
                ? 'Gradient'
                : color
                    ? `rgba(${color.props.red}, ${color.props.green}, ${color.props.blue}, ${color.props.alpha})`
                    : 'None'}`;
        default:
            return `${props.backgroundGradient.stops.length ? 'Gradient' : (color === null || color === void 0 ? void 0 : color.details.title) || 'None'}`;
    }
};
//# sourceMappingURL=fill.js.map